import React, { FunctionComponent, useLayoutEffect, useState, useMemo, useCallback, useRef } from "react";
import { CountUp } from "use-count-up";
import cx from "classnames";
import styles from "./index.module.less";
import { ISpeedCardData } from "@Types/kindSumReport";
import { HeroRanking } from "../common";
import { host } from "@Services/url";

interface IProps {
  id: string;
  dataSource: ISpeedCardData[];
  speedWayData: any
}

const Speedways: FunctionComponent<IProps> = ({ id, dataSource, speedWayData }) => {
  const targetRef: any = useRef<HTMLUListElement>(null);
  const speedRef = useRef<HTMLDivElement>(null);
  const [isShow, setShow] = useState<boolean>(false);

  useLayoutEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          !isShow && setShow(true);
        }
      },
      { threshold: [0.65] },
    );

    speedRef.current && observer.observe(speedRef.current);
  }, [dataSource, isShow]);

  return (
    <div className={styles["speed-ways"]} ref={speedRef}>
      <HeroRanking
        data={{ speedway_yong_an: speedWayData }}
        rankKey={"speedway_yong_an"}
        href={`${host.c}/kind/testing/ranking?fid=speedway_yong_an&tid=0`}
      />
      <div className={styles["title"]}>
        <h4>超級測試賽道成績</h4>
      </div>
      <div className={cx(styles["speed-ways-box"])}>
        <div className={styles["dash-board"]}>
          <div className={styles["dash-board-item"]} style={{left: "-22px"}}>
            <i className={!!isShow ? styles["board-animate"] : ""}></i>
          </div>
          <div className={styles["dash-board-item"]} style={{left: "158px"}}>
            <i className={!!isShow ? styles["board-animate"] : ""}></i>
          </div>
        </div>
        <div className={cx(styles["speed-ways-car"], { [styles["box-more"]]: dataSource.length > 1 })} ref={targetRef}>
          {dataSource.map((item, inx) => (
            <div className={cx(styles["car-item"], { [styles["car-item-big"]]: dataSource.length === 1 })} key={inx}>
              <div className="h-34 flex items-center justify-center">
                <h5>{item.fullName}</h5>
              </div>
              <div className={styles["car-speed"]}>
                <CountUp isCounting={isShow} end={isShow ? Number(item.speed) : 0} duration={3} />秒
              </div>
              <img className={cx(styles["car-thumb"], { [styles["car-animate"]]: isShow })} src={item.thumb} />
              <div className={styles["speed-way-list"]}>
                時間:{item.date} 天氣:{item.weather}
                <br />
                溫度:{item.temperature} 賽道:{item.speedwayName}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={styles["speed-bg"]}></div>
    </div>
  );
};

export default Speedways;
